import {BlockOneSettings} from "./blockOneSettings";
import {useAppDispatch, useAppSelector} from "../../../redux/store";
import {selectCategoryFood, selectSkuFood} from "../../../common/selectors";
import {useEffect} from "react";
import {
    fetchSkuFoodCategoryCount,
    fetchSkuFoodCategoryTC,
    fetchSkuFoodTotalTC
} from "../../../redux/categoryFoodReducer";
import {LevelCategoriesChart} from "./levelCategoriesChart";
import {LevelCategoriesInfo} from "./levelCategoriesInfo";
import {Top10CategoryFoodBarChart} from "./top10CategoryFoodBarChart";
import {Top10CategoryFoodPieChart} from "./top10CategoryFoodPieChart";
import {fetchSkuFoodForChartTC} from "../../../redux/skuFoodReducer";
import {MiddlePriceChart} from "./middlePriceChart";

export const DashboardBlockOne = () => {

    // Инициализация dispatch для отправки экшенов в Redux
    const dispatch = useAppDispatch()

    // Получение данных из Redux store: фильтры и данные для графиков
    const {date, city, store_name, level_category, categoryCountData, categoryData, categoryTotalForBlockOne} = useAppSelector(selectCategoryFood)
    const  {data} = useAppSelector(selectSkuFood)

    // useEffect: при изменении фильтров запрашиваем новые данные для графиков и информации
    useEffect(() => {
        dispatch(fetchSkuFoodCategoryCount({
            city,
            store_name,
            level_category,
            start_date_from: date[0],
            end_date_to: date[1]
        }))
        dispatch(fetchSkuFoodCategoryTC({
            city,
            store_name,
            start_date_from: date[0],
            end_date_to: date[1]
        }))
        dispatch(fetchSkuFoodTotalTC({
            city,
            store_name,
            start_date_from: date[0],
            end_date_to: date[1],
            block: 'one',
            address: ''
        }))
        dispatch(fetchSkuFoodForChartTC({
            start_date_from: date[0],
            end_date_to: date[1],
            city,
            store_name
        }))
    }, [date, city, store_name, level_category]);

    // Отрисовка блока настроек и графиков
    return (
        <div>
            {/* Компонент настроек фильтров для блока 1 */}
            <BlockOneSettings date={date} city={city} store_name={store_name} level_category={level_category}/>
            <div style={{display: 'flex', gap: 20}}>
                <div style={{width: '70%'}}>
                    {categoryCountData && <LevelCategoriesChart data={categoryCountData} city={city} store_name={store_name} level_category={level_category}/>}
                </div>
                <div style={{width: '30%'}}>
                    {categoryData?.length && categoryTotalForBlockOne?.length ? <LevelCategoriesInfo data={categoryData} total={categoryTotalForBlockOne} level_category={level_category}/> : <div>Нет данных</div>}
                </div>
            </div>
            {/* Блок дополнительных графиков, если есть данные */}
            {categoryCountData && <div>
                {/* График средней цены по категориям */}
                {categoryCountData && <MiddlePriceChart data={categoryCountData}/>}
                <div style={{display: 'flex', justifyContent: "space-between", gap: 20, marginTop: 20}}>
                    {/* Топ-10 категорий: столбчатая диаграмма */}
                    <Top10CategoryFoodBarChart data={categoryCountData}/>
                    {/* Топ-10 категорий: круговая диаграмма */}
                    <Top10CategoryFoodPieChart data={categoryCountData}/>
                </div>
            </div>}
        </div>
    );
};
